'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from 'react';
import { fetchFiltersIfNeeded } from '../../actions/FilterActions';
import { mapAcad021Categories, mapSoftwareFiltersWithAll } from '../../constants/TopFilterConstants';
import { useDispatch, useSelector } from 'react-redux';
import CatalogDropdownMenu from './CatalogDropdownMenu';
import MobileCatalogMenu from './MobileCatalogMenu';
import useMediaQuery from '../../hooks/useMediaQuery';
import { device } from '../../constants/StyledComponentConstants';
import PropTypes from 'prop-types';

const CatalogDropdownContainer = ({
  inlineLink,
  selectedGroup,
  selectedFilterType,
  buttonText
}) => {
  const dispatch = useDispatch();
  const isMobile = useMediaQuery(`screen and ${device.mobile}`);
  const isRequesting = useSelector(state => state.filters.get('isRequesting'));
  const categories = useSelector(state => state.filters.get('subCategories'));
  const hsSoftwareFilters = useSelector(state => state.filters.get('hsSoftwareFilters'));
  useEffect(() => {
    dispatch(fetchFiltersIfNeeded());
  }, [dispatch]);
  return !isRequesting && (isMobile ? /*#__PURE__*/_jsx(MobileCatalogMenu, {
    buttonText: buttonText,
    categories: mapAcad021Categories(categories),
    hsSoftwareCategories: mapSoftwareFiltersWithAll(hsSoftwareFilters),
    inlineLink: inlineLink,
    selectedFilterType: selectedFilterType,
    selectedGroup: selectedGroup
  }) : /*#__PURE__*/_jsx(CatalogDropdownMenu, {
    buttonText: buttonText,
    buttonUse: inlineLink ? 'link-on-dark' : 'tertiary-light',
    categories: mapAcad021Categories(categories),
    hsSoftwareCategories: mapSoftwareFiltersWithAll(hsSoftwareFilters)
  }));
};

CatalogDropdownContainer.propTypes = {
  buttonText: PropTypes.node,
  inlineLink: PropTypes.bool,
  selectedFilterType: PropTypes.string,
  selectedGroup: PropTypes.string
};
export default CatalogDropdownContainer;